import { createElement, Component, PropTypes } from 'rlink-react';

import franchiseScene from 'helpers/scenes/franchiseScene';
import Franchise from 'components/Franchises/Franchise';

export default class FranchisePanels extends Component {

  updateDimensions () {
    let parallaxImageSection = Array.from(document.querySelectorAll('#franchises ul.field-items'));
    parallaxImageSection.forEach(imageItem => {
      imageItem.setAttribute('style', `height: ${window.innerHeight}px`);
    });
  }

  componentDidMount () {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
    franchiseScene();
  }

  render () {
    return (
      <section id="node-13" className="node node-single-page-section node-promoted view-mode-full">
        <article id="franchises" className=" clearfix">
          <div className="view view-games view-id-games view-display-id-latest_games view-dom-id-a577dccb2da0b7fd01ee7c9121b8b382">
            <div className="view-content">
              {this.props.franchiseData
                .sort((a, b) => Number.parseInt(a.priority) - Number.parseInt(b.priority))
                .map((item, index) => (
                  <Franchise key={`${item.title}-panel`} data={item} itemNumber={index + 1} />
                ))}
            </div>
          </div>
        </article>
      </section>
    );
  }
}

FranchisePanels.propTypes = {
  franchiseData: PropTypes.arrayOf(PropTypes.object),
};



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Franchises/FranchisePanels.jsx